// Appends further article cards to #article-grid as #article-sentinel scrolls into
// view, one page per fetch of data-more-url until the server reports no more.
(function (window, document) {
  'use strict';

  function init() {
    var sentinel = document.getElementById('article-sentinel');
    var grid = document.getElementById('article-grid');
    if (!sentinel || !grid || !('IntersectionObserver' in window)) return;
    var page = 1;
    var loading = false;

    function stop(observer) {
      observer.disconnect();
      sentinel.remove();
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading) return;
      loading = true;
      page += 1;
      fetch(sentinel.dataset.moreUrl + '?page=' + page, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok || r.redirected) { stop(observer); return null; }
          return r.text().then(function (html) {
            grid.insertAdjacentHTML('beforeend', html);
            if (window.JN.pillFit) window.JN.pillFit(grid);
            if (r.headers.get('X-Has-More') !== '1') stop(observer);
          });
        })
        .catch(function () { stop(observer); })
        .then(function () { loading = false; });
    }, { rootMargin: '200px' });
    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.JN = window.JN || {};
  window.JN.articleFeed = { init: init };
})(window, document);
